<template>
    <div class="block-editor send-email">
        <div class="wrapper">
            <div class="title">Etkinlik Başlangıç Tarihi</div>
            <div class="text-editor-wrapper date">
                <a-radio-group v-model:value="clone.selectType" class="radio-btns">
                    <a-radio value="now" class="radio-btn">Şuan</a-radio>
                    <a-radio value="after" class="radio-btn" style="margin: 10px 0">
                        <input
                            type="number"
                            v-model="afterSelectTimeValue"
                            class="input-number"
                            :disabled="clone.selectType !== 'after'"
                        />
                        <a-select
                            style="width: 170px"
                            v-model="afterSelectTime"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'after'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of timeOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                        <div class="name">After</div>
                        <a-select
                            style="width: 200px"
                            v-model="afterSelectDate"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'after'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of dateOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                    </a-radio>
                    <a-radio value="before" class="radio-btn">
                        <input
                            type="number"
                            v-model="beforeSelectTimeValue"
                            class="input-number"
                            :disabled="clone.selectType !== 'before'"
                        />
                        <a-select
                            style="width: 170px"
                            v-model="beforeSelectTime"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'before'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of timeOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                        <div class="name">Before</div>
                        <a-select
                            style="width: 200px"
                            v-model="beforeSelectDate"
                            show-search
                            @change="changeRepeat"
                            :disabled="clone.selectType !== 'before'"
                        >
                            <a-select-option
                                v-for="(repeatTime, index) of dateOptions"
                                :key="index"
                                :value="repeatTime.value"
                            >
                                {{ repeatTime.label }}
                            </a-select-option>
                        </a-select>
                    </a-radio>
                </a-radio-group>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Etkinlik Süresi</div>
            <div>
                <input type="number" v-model="clone.eventTime" class="input-number" />
                <a-select style="width: 170px" v-model="clone.eventTimeType" show-search @change="changeRepeat">
                    <a-select-option v-for="(repeatTime, index) of timeOptions" :key="index" :value="repeatTime.value">
                        {{ repeatTime.label }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Summary</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="event summary"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.summary"
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Açıklama</div>
            <div class="text-editor-wrapper">
                <TiptapEditor
                    placeholder="event description"
                    :show-attributes="true"
                    :show-emoji="false"
                    v-model="clone.description"
                />
            </div>
        </div>
        <div class="wrapper">
            <div class="title">Temsilciler</div>
            <a-select v-model="clone.selectedUser" show-search style="width: 100%">
                <a-select-option v-for="(user, index) of users" :key="index" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>
        <div class="wrapper">
            <div class="title">Takvimler</div>
            <a-select v-model="clone.selectUserCalendar" show-search style="width: 100%">
                <a-select-option v-for="(user, index) of userCalendars" :key="index" :value="user._id">
                    {{ user.summary }}
                </a-select-option>
            </a-select>
        </div>
        <div class="wrapper">
            <div class="title">Diğer Temsilciler</div>
            <a-select v-model="clone.refUsers" show-search style="width: 100%" mode="tags">
                <a-select-option v-for="(user, index) of users" :key="index" :value="user._id">
                    {{ user.name }}
                </a-select-option>
            </a-select>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import { mapActions, mapState } from "vuex";

const log = log2("CreateEvent");
export default {
    name: "CreateEvent",
    components: { TiptapEditor },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep(this.value),
            selectType: "now",
            afterSelectTime: "minutes",
            afterSelectDate: "now_date",
            afterSelectTimeValue: 10,
            beforeSelectTime: "minutes",
            beforeSelectDate: "now_date",
            beforeSelectTimeValue: 10,
            userCalendars: [],
            timeOptions: [
                {
                    label: "gün",
                    value: "days",
                },
                {
                    label: "saat",
                    value: "hours",
                },
                {
                    label: "dakika",
                    value: "minutes",
                },
            ],
            dateOptions: [
                {
                    label: "Şuanki zaman",
                    value: "now_date",
                },
                {
                    label: "Chat başlama zamanı",
                    value: "chat_date",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
    },
    methods: {
        ...mapActions({
            getUserCalendars: "calendar/getUserCalendars",
        }),
        changeRepeat(val) {
            this.customRepeatModal = val === "custom";
        },
    },
    mounted() {
        console.log("create event this.clone", this.clone);
        this.clone.eventTime = this.clone.eventTime || 10;
        this.clone.eventTimeType = this.clone.eventTimeType || "minutes";
        if (this.clone.selectType === "after") {
            this.afterSelectTimeValue = this.clone.timeNumber;
            this.afterSelectTime = this.clone.timeType;
            this.afterSelectDate = this.clone.dateType;
        } else if (this.clone.selectType === "before") {
            this.beforeSelectTimeValue = this.clone.timeNumber;
            this.beforeSelectTime = this.clone.timeType;
            this.beforeSelectDate = this.clone.dateType;
        }
        console.log("this.clone.selectedUser", this.clone.selectedUser);
        if (this.clone.selectedUser !== "") {
            this.getUserCalendars(this.clone.selectedUser).then((res) => {
                this.userCalendars = res;
            });
        }
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        async "clone.selectedUser"(val) {
            this.clone.selectUserCalendar = null;
            console.log("clone.selectedUser", val);
            if (this.clone.selectedUser === "") return;
            this.getUserCalendars(val).then((res) => {
                this.userCalendars = res;
            });
        },
        afterSelectTimeValue(val) {
            this.clone["timeNumber"] = val;
        },
        beforeSelectTimeValue(val) {
            this.clone["timeNumber"] = val;
        },
        afterSelectTime(val) {
            this.clone["timeType"] = val;
        },
        beforeSelectTime(val) {
            this.clone["timeType"] = val;
        },
        afterSelectDate(val) {
            this.clone["dateType"] = val;
        },
        beforeSelectDate(val) {
            this.clone["dateType"] = val;
        },
    },
};
</script>

<style lang="scss">
.input-number {
    border: 0.5px solid grey;
    border-radius: 10px;
    height: 30px;
    width: 50px;
    margin-right: 10px;
}

.block-editor.send-email {
    display: flex;
    flex-direction: column;
    gap: 5px;

    .radio-btns {
        display: flex;
        flex-direction: column;

        .name {
            font-weight: 700;
            margin: 0 10px;
        }

        .radio-btn {
            display: flex;
            align-items: center;
        }
    }

    .wrapper {
        padding: 10px;

        .title {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .text-editor-wrapper {
            border-radius: 0px;
            border: 1px solid #fff;
            background: white;

            &.date {
                padding: 10px;
            }

            &:hover {
                border: 1px solid #006cff !important;
            }
        }

        .ant-select {
            width: 100%;
        }
    }
}
</style>
